@use '../../../../../css/variables/dashboard.scss';
@use '~@frontrow/console/css/variables.scss';

@forward '../../../../../css/variables/dashboard.scss';
@forward '~@frontrow/console/css/variables.scss';

$sidebar-header-height: 70px;

.sidebar {
  position: fixed;
  height: 100%;
  background: #1c262f;
  width: dashboard.$sidebar-width;
  overflow-x: hidden;
  top: 0;
}

.sidebarWrapper {
  height: 100%;
  padding-bottom: variables.$std-padding-lg;
  box-sizing: border-box;
}

.linksWrapper {
  flex: 1;
}

.sidebarHeader {
  height: $sidebar-header-height;
  display: flex;
  justify-content: center;
  align-items: center;
  border-bottom: 1px solid #4a4a4a;
}

.sidebarLinks {
  margin-top: variables.$std-margin-lg;
  padding-left: 0;
  flex: 1;
}

.bottomLinks {
  text-align: center;
  margin-bottom: variables.$std-margin-xlg;
  padding: 0 variables.$std-padding-xs;
}

.sidebarBugsLink {
  font-size: 20px;
  margin-bottom: variables.$std-margin-xs;
  width: 100%;
  padding: variables.$std-padding-xs variables.$std-padding-xxs;
  height: auto !important;
  box-sizing: border-box;
}

.logoutWrapper {
  color: variables.$white;
  text-align: center;
  display: flex;
  flex-direction: column;
  overflow-wrap: break-word;
  padding: variables.$std-margin-xs variables.$std-margin-xs;
}

.logoutButton {
  background: #1c262f;
  border-color: #1c262f;
}
